import Emitter from "./Emitter";

export default class KeepAlive extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ event: 'keepAlive' });
    }

    POKERSTARS_handler() {
        return;
    }

    PLAYTECH_handler(data) {
        return;
    }

    _default() {
        this.emitTop({ wpgaction: "keepAlive" });
        this.emitParent({ wpgaction: "keepAlive.parent" });
        this.emitiOS({ wpgaction: "keepAlive" });
    }
}
